import { EEnvironment } from "../enums/env.enums";

export function inferEnvironment(): EEnvironment {
  if (window.location.host.includes("qa")) return EEnvironment.QA;
  else if (window.location.host.includes("dev")) return EEnvironment.DEV;
  else if (window.location.host.includes("localhost"))
    return EEnvironment.LOCALDEV;
  else return EEnvironment.PROD;
}

let savedEnvironment: EEnvironment | null = null;

export function getEnvironment(): EEnvironment {
  if (!savedEnvironment) {
    savedEnvironment = inferEnvironment();
  }
  return savedEnvironment;
}

export function setEnvironment(env: EEnvironment | null): void {
  savedEnvironment = env;
}
